import { useMemo } from 'react'
import { useRemoteSessionId } from './useRemoteSessionId'
import { useMediaTrackState } from './useMediaTrackState'

export function useRemoteMediaTrackState() {
  const { remoteSessionId } = useRemoteSessionId()
  const { isVideoTrackOn, isAudioTrackOn } = useMediaTrackState(remoteSessionId)

  return useMemo(() => ({ isVideoTrackOn, isAudioTrackOn }), [isVideoTrackOn, isAudioTrackOn])
}
